if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const variantIdInput = this.form.querySelector('[name=id]');
        if (variantIdInput?.value) variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.giftRecipientName = this.querySelector('#RecipientName');
        this.giftRecipientEmail = this.querySelector('#RecipientEmail');
        this.recipientGreeting = this.querySelector('#GreetingsForRecipient');
        this.giftMessageError = this.recipientGreeting
          ? document.getElementById(this.recipientGreeting.getAttribute('aria-describedby'))
          : null;
        this.giftUIMessage = this.querySelector('.gift-popup-content.content p');
        this.closeGiftingBtn = this.querySelector('#ModalClose-SendGift');
        this.btnNow = this.querySelector('[data-now-button]');
        this.sendAtInput = this.querySelector('input[data-date-input]');
        this.sendAtIsoDate = this.querySelector('input[data-iso-date]');

        
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        if (this.recipientGreeting) {
          this.recipientGreeting.addEventListener('input', () => {
            this.updateGiftMsgUI();
            this.validateGiftMessage();
          });
        }
      }

      convertSendAtToUtc() {
        if(this.sendAtInput && this.sendAtInput.value != null && this.sendAtInput.value.length > 1) {   
          const localDate = new Date(this.sendAtInput.value);    
          // const currentDate = new Date();

          // const utcDate = new Date(
          //   localDate.getTime() + currentDate.getTimezoneOffset() * 60000
          // );
          const utcDatetimeString = localDate.toISOString();
          // this.sendAtInput.value = utcDatetimeString;
          this.sendAtIsoDate.value = utcDatetimeString;
          this.sendAtIsoDate.setAttribute('name','properties[_gift_send_at]');
        } 
      }

      updateGiftMsgUI(){
        if (this.giftUIMessage && this.recipientGreeting) {
          this.giftUIMessage.innerText = this.recipientGreeting.value;
        }
      }

      validateGiftMessage() {
        if (!this.recipientGreeting) return true;

        const maxLength = Number(this.recipientGreeting.dataset.maxlength) || 500;
        const isOverLimit = this.recipientGreeting.value.length > maxLength;
        const label = this.querySelector(`label[for="${this.recipientGreeting.id}"]`);
        const errorMessage =
          this.giftMessageError?.querySelector('.form__message')?.innerText?.trim() ||
          `Maximum ${maxLength} characters allowed.`;

        if (isOverLimit) {
          this.recipientGreeting.classList.add('is-error');
          label?.classList.add('is-error');
          this.recipientGreeting.setAttribute('aria-invalid', 'true');
          this.recipientGreeting.setCustomValidity(errorMessage);
          if (this.giftMessageError) this.giftMessageError.hidden = false;
          return false;
        }

        this.recipientGreeting.classList.remove('is-error');
        label?.classList.remove('is-error');
        this.recipientGreeting.removeAttribute('aria-invalid');
        this.recipientGreeting.setCustomValidity('');
        if (this.giftMessageError) this.giftMessageError.hidden = true;
        return true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.recipientGreeting && !this.validateGiftMessage()) {
          this.recipientGreeting.focus();
          return;
        }
        if (!this.form.reportValidity()) return;

        if (this.shouldValidateVariantSelection() && !this.isVariantSelected()) {
          const isGiftCard = this.submitButton?.classList.contains('gift-atc-btn');
          this.handleErrorMessage(
            isGiftCard ? window.variantStrings.chooseAmountError : window.variantStrings.chooseSizeError
          );
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        this.convertSendAtToUtc();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            this.dispatchEvent(
              new CustomEvent('add-to-cart', {
                bubbles: true,
                detail: {
                  status: 'success',
                  source: 'product-form',
                  items: [response],
                },
              })
            );

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if(this.closeGiftingBtn) this.closeGiftingBtn.click();
            if(this.giftRecipientName) this.giftRecipientName.value = null;
            if(this.giftRecipientEmail) this.giftRecipientEmail.value = null;
            if(this.recipientGreeting) {
              this.recipientGreeting.value = null;
              this.validateGiftMessage();
            }
            if(this.sendAtInput) this.sendAtInput.value = null;
            if(this.sendAtIsoDate) this.sendAtIsoDate.value = null;
            if(this.sendAtIsoDate) this.sendAtIsoDate.removeAttribute('name');
            if(this.sendAtInput) this.sendAtInput.classList.remove("is-active");
            if(this.btnNow) this.btnNow.classList.add("is-active");

            if(this.giftUIMessage) this.giftUIMessage.innerText = "Enjoy your gift!";
          });
      }

      shouldValidateVariantSelection() {
        return (
          this.dataset.desktopAtcValidation === 'true' &&
          window.matchMedia('(min-width: 750px)').matches
        );
      }

      isVariantSelected() {
        const variantPicker = document.querySelector('variant-selects, variant-radios');
        if (!variantPicker) return true;

        if (variantPicker.tagName === 'VARIANT-RADIOS') {
          return Array.from(variantPicker.querySelectorAll('fieldset')).every((fieldset) =>
            fieldset.querySelector('input:checked')
          );
        }

        return Array.from(variantPicker.querySelectorAll('select')).every((select) => select.value !== '');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (window && window.atcBtn === undefined) {
  const atcBtn = document.querySelector('.product-form .product-form__submit');
  if (atcBtn) {
    atcBtn.addEventListener('click', (event) => {
      let btn = event.target;
      if (event.target.tagName !== 'BUTTON') {
        btn = event.target.closest('button');
      }
      const textLabel = btn.querySelector('[data-choose-text]');
      if (!textLabel || textLabel.textContent !== textLabel.dataset.chooseText) {
        return;
      }
      document.querySelector('.product-form__variants')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      event.preventDefault();
      event.stopPropagation();
      return false;
    });
  }
}
